import { makeAutoObservable } from "mobx";
import { v4 as uuidv4 } from "uuid";

export interface TerminalSession {
    id: string;
    label: string;
}

export class TerminalStore {
    terminalSessions: TerminalSession[] = [];

    private _root: any;

    constructor(root: any) {
        this._root = root;
        makeAutoObservable(this, { _root: false });
    }

    syncSessions(sessions: Array<{ id: string; cwd: string | null; is_alive: boolean }>) {
        const serverIds = new Set(sessions.map(s => s.id));
        this.terminalSessions = this.terminalSessions.filter(s => serverIds.has(s.id));
        for (const s of sessions) {
            if (!this.terminalSessions.find(t => t.id === s.id)) {
                this.terminalSessions.push({
                    id: s.id,
                    label: s.name || s.id,
                });
            }
        }
    }

    openNewTerminal(): string {
        const id = uuidv4();
        const cwd = this._root.agent.getProjectRoot();
        const label = cwd ? cwd.split("/").pop() || "terminal" : "terminal";
        this.terminalSessions.push({ id, label });
        return id;
    }

    closeTerminalSession(id: string) {
        this.terminalSessions = this.terminalSessions.filter(s => s.id !== id);
        // TODO(app-model): "close_terminal_session" no longer has a backend handler (old
        // agent.api.handlers.terminal was removed) -- wire to
        // DeploymentContext.destroy_terminal_session via the app-model RPC surface once this
        // store holds a container entity.
    }
}
